import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { NG1_BASKET_STORE } from '@commons/core/core.provider.ajs';

import { ChannelType } from '@contact/upgrade';

import { BasketAction, fromBasket } from './';
import { IBasketStore } from './basket.store';

const MODULE_NAME = 'contactBasket';

@Component({
  selector: 'cng-basket',
  templateUrl: './basket.component.html',
  styleUrls: ['./basket.component.scss'],
})
export class BasketComponent implements OnInit, OnDestroy {
  readonly ChannelType = ChannelType;

  readonly channelSelected$ = this.basketStore.pipe(fromBasket.selectChannelSelected());

  constructor(@Inject(NG1_BASKET_STORE) private readonly basketStore: IBasketStore) {}

  ngOnInit(): void {
    this.basketStore.dispatch(new BasketAction.OpenBasket());
  }

  ngOnDestroy(): void {
    this.basketStore.dispatch(new BasketAction.CloseBasket());
  }

  changeChannel(channel: ChannelType) {
    // switch channel type
    this.basketStore.dispatch(new BasketAction.ChangeChannel(channel));
  }

  isChannel(selected: ChannelType, channel: ChannelType): boolean {
    return selected === channel;
  }
}
